import * as amplify from "./amplify.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import * as modal from "./modal.ts";
import ApiServer from "../ApiServer.ts";
import * as Html from "./Html.ts";
import * as FwDatas from "../FwDatas.ts";
import TPL_TASK_CONTAINER_CONTENT from "../list/task-container-content.mustache";
import {toUnicodeVariant} from "../lib/toUnicodeVariant.ts"
import Icons from "../svg/Icons.ts";
import { registerDragStart} from "../lib/FileUtils.ts";
import { MetaTaskCache } from "../server/objects/TaskBeans.ts";
import TPL_tasklist_list_item from "../list/tasklist_list_item.mustache"
import TPL_task_item from "../list/task.mustache"
import { checkTaskLimitOntry, taskdeletemarkedraw, taskHardLimitReach } from "../list/list_clean.ts";


function listcreatereally(type){
  modal.closeDomModal();
  import("../list/list_create.mustache").then(function(TPL){
    const
      theModal = modal.openDomModal(TPL,new ApiServer.types.ITaskList({taskListType:type,sharedToAll:"true",rights:{},sharedMemberIds:[]})),
      form = theModal.querySelector("form") as HTMLFormElement;
    form.setAttribute('data-fw-dyn-action','custom.listcreate');
    ApiServer["custom.listcreate"] = ApiServer.taskcreatelist.prepare(function(cat){
      modal.closeDomModal(theModal);
      amplify.publish("taskNeedRefresh");
      libLocation.goTo('?metaId='+cat.metaId,true)
    });
  });
}

Html.registerDom({
  async taskmarkinlist(complete){
    const
      node = Html.getDomMetaIdNode(this),
      metaId = Html.getDomMetaId(this),
      [updated,[lists]] = await Promise.all(
        [
          ApiServer.taskmark.setOptions({progressbar:'none'})(metaId,complete),
          MetaTaskCache.refresh()
        ]),
      currentList = lists.find(list=>list.metaId === updated.taskListId);

    let listItemNode = document.querySelector(`.selectable>*[data-fw-meta-id="${currentList.metaId}"]`) as HTMLElement;
    const isSelected = listItemNode?.classList.contains('selected');

    listItemNode = Html.replaceWithSingleDom(listItemNode,TPL_tasklist_list_item,currentList);
    if(listItemNode){
      listItemNode.classList.toggle('selected',isSelected);
    }

    Html.replaceWithSingleDom(node,TPL_task_item,updated);
  },
  async listcreate(){
    const button = await modal.pick({
      title:"catsystem.picktype",
      cssClass:"large",
      gap:"var(--space-s)",
      button:[
        {title:"catsystem.SYS-CAT-SHOPPINGLIST",text:"catsystem.SYS-CAT-SHOPPINGLISTtext",icon:Icons.list.create_list_type_illustration_groceries,onclick:()=>listcreatereally("SHOPPING_LIST")},
        {title:"catsystem.SYS-CAT-TODOS",text:"catsystem.SYS-CAT-TODOStext",icon:Icons.list.create_list_type_illustration_todo,onclick:()=>listcreatereally("TODOS")},
        {title:"catsystem.SYS-CAT-OTHER",text:"catsystem.SYS-CAT-OTHERtext",icon:Icons.list.create_list_type_illustration_other,onclick:()=>listcreatereally("OTHER")}

      ]})
    if(button){
      button.onclick()
    }

  },
  listcreatereally,

  async listdelete(){
    const
      metaId = Html.getDomMetaId(this),
      list = FwDatas.get(metaId);
    modal.closeDomModal();
    if(list.system){
      if(!await modal.confirmDelete({
        title:"lists_delete_system_list_confirmation_title",
        message:"lists_delete_system_list_confirmation_message"
      })) return;
    }else{
      if(!await modal.confirmDelete("catsystem.deleteconfirm")) return;
    }
    ApiServer.taskdeletelist(metaId);
    amplify.publish("taskNeedRefresh");
  },
  listedit(){
    const
      catNode = Html.getDomMetaIdNode(this),
      list = FwDatas.get([Html.getDomMetaId(catNode)]);
    import("../list/list_create.mustache").then(function(TPL){
      const
        theModal = modal.openDomModal(TPL,list),
        form = theModal.querySelector("form") as HTMLFormElement;

      form.setAttribute('data-fw-dyn-action','custom.listedit');
      ApiServer['custom.listedit'] = ApiServer.taskupdatelist.prepare({metaId:list.metaId},function(){
        amplify.publish("taskNeedRefresh")
        modal.closeDomModal(theModal);
      });
    });
  },
  listeditsharing(){
    const
      catNode = Html.getDomMetaIdNode(this),
      list = FwDatas.get([Html.getDomMetaId(catNode)]);
    import("../list/list_editsharing.mustache").then(function(TPL){
      const theModal = modal.openDomModal(TPL,list);
      const form = theModal.querySelector("form") as HTMLFormElement;
      form.addEventListener("submit", function(this:HTMLFormElement,evt){
        evt.preventDefault();
        modal.closeDomModal(theModal);
        ApiServer.taskupdatelist(this)
        amplify.publish("taskNeedRefresh")
      });
    });
  },
  listshowhidecompleted(completedHidden){
    const metaId = Html.getDomMetaId(this);

    //do not send all list beause of a serveur bug
    ApiServer.taskupdatelist({metaId,completedHidden});
    amplify.publish('taskNeedRefresh')

  },
  taskmarkall(){
    const metaId = Html.getDomMetaId(this);

    ApiServer.taskmetamark([metaId],true);
    amplify.publish("taskNeedRefresh")
   },
  taskunmarkall(){
    const metaId = Html.getDomMetaId(this);

    ApiServer.taskmetamark([metaId],false);

    amplify.publish("taskNeedRefresh")
  },
  taskdeletemarked(metaId = Html.getDomMetaId(this)){
    taskdeletemarkedraw(metaId)
  },
  taskduplicatelist(){
    const metaId = Html.getDomMetaId(this);

    ApiServer.taskduplicatelist(metaId,function(newList){
      modal.snackDone('catsystem.duplicatedone')
      libLocation.goTo('?metaId='+newList.metaId,true)
    },e=>{
      if(e.code==='610' && e.type==='task'){
        taskHardLimitReach(metaId)
      }else{
        throw e;
      }
    });
    amplify.publish("taskNeedRefresh")
  },
  tasklistsort(sortby){
    const
      catNode = Html.getDomMetaIdNode(this),
      list = FwDatas.get([Html.getDomMetaId(catNode)]);

    list.taskSorting = sortby;
    //do not send all list beause of a serveur bug
    ApiServer.taskupdatelist.setOptions({progressbar:'none'})({metaId:list.metaId,taskSorting:sortby});
    list.sort();
    import("../list/tasksortby.mustache").then(function(TPLSORT){
      const taskContainer = catNode.querySelector<HTMLElement>('#task-container');
      const sortingTasks = catNode.querySelector<HTMLElement>('.fw-sorting-tasks');
      if(taskContainer) Html.setHtml(taskContainer,TPL_TASK_CONTAINER_CONTENT,list);
      if(sortingTasks) Html.setHtml(sortingTasks,TPLSORT,list);
    });
  },

  tasklistcategoryhide(hide){
    const
      catNode = Html.getDomMetaIdNode(this),
      list = FwDatas.get([Html.getDomMetaId(catNode)]);
    list.taskCategoriesHidden = hide;
    ApiServer.taskupdatelist.setOptions({progressbar:'none'})({metaId:list.metaId,taskCategoriesHidden:hide});
    amplify.publish("taskNeedRefresh");
  },
  async listshare(){
    const
      catNode = Html.getDomMetaIdNode(this),
      list = FwDatas.get([Html.getDomMetaId(catNode)]),
      taskByCategory = list.taskByCategory();

    let text;

    if(list.taskCategoriesHidden){
      text = `${list.name}
${list.ongoing.map(task=>`  □ ${task.text}`).join('\r\n')}
${list.complete.map(task=>`  ✓ ${task.text}`).join('\r\n')}
`;
    }else{
      text = `${toUnicodeVariant(list.name.toLocaleUpperCase(),'bold')}
${taskByCategory.map(pair=>`
${pair.category.emoji}\t${toUnicodeVariant(pair.category.name.toLocaleUpperCase(),'bold')}
${pair.items.map(task=>`\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0${task.computedComplete?'🗹':'❏'}\u00a0\u00a0${toUnicodeVariant(task.text,'italic',task.complete?'strike':undefined)}`).join('\n')}
`).join('')}

${i18n.get('share.footer')}
\u00a0
`;
    }
    try{
      await navigator.share({text})
    }catch(e){
      modal.oops('fw2.defaultError')
    }
  }


});

ApiServer["custom.taskquickadd"] = async function(form: HTMLFormElement){
  const
    catNode = Html.getDomMetaIdNode(form),
    taskListId = Html.getDomMetaId(catNode),
    list = FwDatas.get(taskListId),
    formData = ApiServer.flattenForm(form),
    text = formData.text[0];

  setTimeout(function(){
    form.reset();
    //TODO understand why the reset does not do that
    (form as any).taskCategoryId.value='';
  },0)
 // focusListId = list.metaId;
  //check if we unmark
  var completeTaskWithSameName = list.complete.filter(function(task) {
    return formData.text.indexOf(task.text)>-1;
  })[0];

  if(completeTaskWithSameName){
    ApiServer.taskmark(completeTaskWithSameName.metaId,false);
    ApiServer.taskmove(completeTaskWithSameName.metaId);
  }else{
    if(await checkTaskLimitOntry()){
      if(text.indexOf('http')===0){
        ApiServer.webog(text,function(ogBean){
          formData.description = formData.text;
          formData.text = ogBean.title||formData.text;
          ApiServer.taskcreate2(formData);
          amplify.publish("taskNeedRefresh")
        })
        return;
      }else{
        ApiServer.taskcreate2(formData);
        amplify.publish("taskNeedRefresh")
      }
    }else{
      taskHardLimitReach(taskListId)
      return;
    }
  }
  amplify.publish("taskNeedRefresh")
  amplify.subscribe("taskRefreshed",function refocus(){
    const ghostInput = document.querySelector('.formquickadd .ghost') as HTMLElement;
    setTimeout(() => ghostInput?.focus(), 50);
    amplify.unsubscribe("taskRefreshed",refocus)
  })
}

document.addEventListener("selectstart", Html.createDelegateListener(
  '.fw-todo',
  function(ev: Event){
    ev.preventDefault()
  }
));

/* with sorting */
registerDragStart(".fw-todo",async function(this: HTMLElement, ev: DragEvent, dropPromiseBuilder: any){
  const
    dropEvent = await dropPromiseBuilder(this,Array.from(document.querySelectorAll(".fw-todo, .fw-category-header, .fw-tasklist-header"))),
    metaId = Html.getDomMetaId(this),
    target = dropEvent.target as HTMLElement;

  if(target.classList.contains('fw-todo')){
    let
      prevTaskNode = Html.getDomMetaIdNode(target),
      categoryNode = target.closest('.fw-category-header') as HTMLElement;

    const rect = (ev.target as HTMLElement).getBoundingClientRect();
    if(rect.top + rect.height/2 > ev.clientY){
      prevTaskNode = prevTaskNode.previousElementSibling as HTMLElement;
    }
    ApiServer.taskmove({taskId:metaId,prevTaskId:Html.getDomMetaId(prevTaskNode),taskCategoryId:Html.getDomMetaId(categoryNode)})
  }else if(target.classList.contains('fw-category-header')){
    ApiServer.taskmove({taskId:metaId,taskCategoryId:Html.getDomMetaId(target)||'$empty'})

  }else if(target.classList.contains('fw-tasklist-header')){
    ApiServer.taskmove({taskId:metaId,taskListId:Html.getDomMetaId(target)||'$empty'})

  }
  amplify.publish("taskNeedRefresh")

});